export const environment = {
  production: false,
  cmaapiUrl: "https://cma-api.mileseducation.com/",
  apiUrl: "https://cpa-api.mileseducation.com/",

  masterApiUrl: "https://masterclass-dev.miles-api.com/api/",

  livecpaurl: "https://cpa-lms-dev.web.app/",
  old_lms_url: "http://cpa-v0.mileseducation.com/",
  jagsom_url: "https://pg.mileseducation.com",
  qrScanBaseUrl: "https://mileseducation.com/milesone/app/web_login/",
  cairaProgressUrl: "https://api.milescaira.com/",
  // The real address the device-gate tells a small-screen student to reopen on
  // — deliberately the PROD URL even in dev/UAT builds (they read it off one
  // screen and type it into another). CAIRA lives under /lms/caira-ready/ in CPA.
  cairaLoginUrl: "https://cpa.mileseducation.com/lms/caira-ready/login",

  mentoringurl:
    "https://miles-lms-mentoring-live-dot-me-server-1.el.r.appspot.com/",
  cdnUrl:
    "https://storage.googleapis.com/miles-next_website-lms-gptool/educational_documents",
  // apiUrl: "http://localhost:3801/",

  authTokenKey: "auth8983a0c22a0529c1c646dd0dc2aaaf68",
  fofAuthTokenKey: "foftoken",

  firebase: {
    apiKey: "AIzaSyArkO_mN7VjYrtmtUsp6eMqga-aahNftCo",
    authDomain: "miles-firebase-projects.firebaseapp.com",
    projectId: "miles-firebase-projects",
    storageBucket: "miles-firebase-projects.appspot.com",
    messagingSenderId: "756926493455",
    appId: "1:756926493455:web:cd7ccbd72a3cb1dbe0047a",
    measurementId: "G-0Y63HJBX5T",
  },
};
